import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { SingleInquiryFormItem, SingleInquiryFormValues } from './models/single-inquiry-form-values';

const fieldNames = fields<SingleInquiryFormValues>();
const itemFieldNames = fields<SingleInquiryFormItem>();

export const singleInquiryValidationSchema = Yup.object().shape({
    [fieldNames.items]: Yup.array().of(
        Yup.object().shape({
            [itemFieldNames.articleName]: Yup.string().required('app.error.required'),
            [itemFieldNames.quantity]: Yup.number()
                .typeError('app.error.required')
                .required('app.error.required')
                .moreThan(0, 'app.error.greaterZero'),
        })
    ),
    [fieldNames.deliveryAddressId]: Yup.number().typeError('app.error.required').required('app.error.required'),
    [fieldNames.deliveryDate]: Yup.date()
        .typeError('app.error.dateInvalid')
        .nullable()
        .min(new Date(), 'app.error.dateInPast'),
});
